import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SwUpdateService } from './shared/services/sw-update.service';
import { environment } from 'src/environments/environment';
import { ZardSonnerComponent } from './shared/components/ui/sonner/sonner.component';

@Component({
  selector: 'app-root',
  template: `
    <router-outlet></router-outlet>
    <z-sonner position="bottom-right" [richColors]="true" [expand]="false" [closeButton]="true"/>
  `,
  styles: [
    ':host {display: block; height: 100%; width: 100%; overflow: hidden;}'
  ],
  standalone: true,
  imports: [RouterOutlet, ZardSonnerComponent]
})
export class AppComponent {
  title = 'UX.Report.Angular';

  public readonly _swUpdateService: SwUpdateService = inject(SwUpdateService);

  constructor() {
    if (!environment.production)
      return;

    this._swUpdateService.checkForUpdateEvery(1);
  }
}
